module.exports = __webpack_public_path__ + "img/placeholder.9e3f64ea.jpg";